import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getBaseUrl, getBaseUrlForKos } from './baseUrl';
import buildQueryString from './buildQueryString';

function kosBaseQuery({ endpoint = '', baseUrl = getBaseUrl() }) {
    if (!baseUrl) {
        throw new Error('Base URL is not defined');
    }

    // Determine if credentials should be included
    const isKosApi = baseUrl === getBaseUrlForKos();
    const fetchOptions = {
        baseUrl: baseUrl + endpoint,
        ...(isKosApi ? { credentials: 'include' } : {}),
    };

    const baseQuery = fetchBaseQuery(fetchOptions);

    return async (args, api, extraOptions) => {
        let url = typeof args === 'string' ? args : args.url;
        if (typeof args === 'object' && 'params' in args && args.params) {
            const queryString = buildQueryString(args.params);
            url = `${url}?${queryString}`;
            args = { ...args, url, params: undefined };
        }
        return baseQuery(args, api, extraOptions);
    };
}

export default kosBaseQuery;
